import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import moment from "moment";

const LogDetailsModal = ({ isOpen, toggle, title, data }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="xl"
      className="modal-dialog-scrollable"
      fade={true}
    >
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        {data.length > 0 ? (
          <div className="modal-content-container">
            <Table responsive hover>
              <thead>
                <tr className="table-modal-header">
                  <th>Número</th>
                  <th>Fantasia</th>
                  <th>Nome Arquivo</th>
                  <th>Inconsistências</th>
                  <th>Data Emissão</th>
                </tr>
              </thead>
              <tbody>
                {data.map((detail, index) => (
                  <tr key={index}>
                    <td className="table-modal-cell">{detail.Numero}</td>
                    <td className="table-modal-cell">{detail.Fantasia}</td>
                    <td
                      className="table-modal-cell-medium"
                      title={detail.NomeArquivo}
                    >
                      {detail.NomeArquivo}
                    </td>
                    <td
                      className="table-modal-cell-long"
                      title={detail.Inconsistencias}
                    >
                      {detail.Inconsistencias}
                    </td>
                    <td className="table-modal-cell">
                      {moment(detail.Dat_Emissao).format("DD/MM/YYYY HH:mm")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <p className="no-details-text">Nenhum detalhe encontrado.</p>
        )}
      </ModalBody>
    </Modal>
  );
};

LogDetailsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      Numero: PropTypes.string.isRequired,
      Fantasia: PropTypes.string,
      NomeArquivo: PropTypes.string.isRequired,
      Inconsistencias: PropTypes.string.isRequired,
      Dat_Emissao: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default LogDetailsModal;
